var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app-bar',{attrs:{"dense":""}},[_c('v-toolbar-title',{staticClass:"text-center m-auto",attrs:{"elevation":"0","full-width":""}},[_c('img',{attrs:{"src":require("../../../assets/images/todaystore/logo-logo-tr-b.svg")}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }